module.exports = __webpack_public_path__ + "img/logo.47189203.png";